import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";

const HeroContainer = tw.div`bg-blue-900 py-3`;
const HeroHeading = tw.h1`container mx-4 sm:mx-auto leading-tight text-white text-4xl font-bold`;

const Hero = ({ children, imgQuery }) => (
  <HeroContainer>
    <HeroHeading>{children}</HeroHeading>
  </HeroContainer>
);

Hero.propTypes = {
  children: PropTypes.node,
};

export default Hero;
